<template>
    <el-form class="user-account-key" ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="用户名">
            <el-input disabled placeholder="请输入用户名" v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password1">
            <el-input type="password" placeholder="请输入密码" v-model="form.password1"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
            <el-input placeholder="请输入邮箱" v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="authcode">
            <el-row>
                <el-col :span="18">
                    <el-input placeholder="请输入验证码" v-model="form.authcode"></el-input>
                </el-col>
                <el-col :span="6" style="text-align:center">
                    <el-button
                        type="warning"
                        @click="getAuthCode(form)"
                        :disabled="!send"
                        v-if="!form.authcode"
                    >
                        <span v-show="send">发送验证码</span>
                        <span v-show="!send" class="count">{{count}} s</span>
                    </el-button>
                    <el-button type="success" @click="activeAuthCode(form)" v-else>点击更换邮箱</el-button>
                </el-col>
            </el-row>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit" :disabled="flag">保存</el-button>
            <!-- <el-button @click="$refs['form'].resetFields()">重置</el-button> -->
        </el-form-item>
    </el-form>
</template>

<script>
import { getCurUserInfo, emailChange } from "@/api/system/user";
import { mapGetters, mapActions } from "vuex";

const TIME_COUNT = 60; // 倒计时的时间

export default {
    data() {
        let checkEmail = (rule, value, callback) => {
            const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
            if (mailReg.test(value)) {
                callback();
            } else {
                callback(new Error("请输入正确的邮箱格式"));
            }
        };
        return {
            form: {},
            send: true,
            flag: true,
            count: "",
            authCodeTimer: null,
            rules: {
                password1: [
                    { required: true, message: "请输入密码", trigger: "blur" }
                ],
                email: [
                    { required: true, message: "请输入邮箱", trigger: "blur" },
                    { validator: checkEmail, trigger: "blur" }
                ],
                authcode: [
                    { required: true, message: "请输入验证码", trigger: "blur" }
                ]
            }
        };
    },
    computed: {
        ...mapGetters(["userInfo"])
    },
    methods: {
        ...mapActions(["setUserinfo"]),
        getCurUserInfo() {
            getCurUserInfo().then(userInfo => {
                this.form = { ...userInfo };
                this.setUserinfo(userInfo);
                this.$message.success("操作成功!");
            });
        },
        emailChange(data, flag) {
            let params = {
                username: data.username,
                password: data.password1,
                email: data.email
            };
            if (data.authcode) params.code = data.authcode;
            emailChange(params)
                .then(() => {
                    if (flag) {
                        this.$message.success("邮箱更换成功!");
                        this.flag = false
                    }
                }).catch(() => {
                    this.flag = true
                });
        },
        activeAuthCode(data) {
            this.emailChange(data, true);
        },
        getAuthCode(data) {
            //发送邮箱验证码
            if (!this.authCodeTimer) {
                this.count = TIME_COUNT;
                this.send = false;
                this.emailChange(data);
                this.authCodeTimer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.send = true;
                        clearInterval(this.authCodeTimer);
                        this.authCodeTimer = null;
                    }
                }, 1000);
            }
        },
        submit() {
            this.getCurUserInfo();
        }
    },
    created() {
        const { email, username } = this.userInfo;
        this.form = { email, username };
    }
};
</script>

<style lang="scss">
.user-account-key {
    padding: 36px 48px 30px 0;
}
</style>

